import React from "react";
import "./EcommerceCheckoutPage.scss"
import failed from "../../../assets/failed.svg"
import { useHistory } from "react-router";
import Button from "../../../components/Button/Button";
const EcommerceFailed = () => {
    const history = useHistory()
    return (
        <div className="EcommerceSuccess">
            <div className="EcommerceSuccess-inner-cont">
                <img alt="" src={failed} className="success-icon" />
                <div className="EcommerceSuccess-header-text">Oops! Your Order Couldn't Be Placed</div>
                <div className="EcommerceSuccess-sub-text">Something went wrong while placing your order. Please try again shortly.</div>
                <div className="back-home-btn"
                ><Button text={"Try Again"}
                    onClick={() => {
                        history.push("/pages/checkout")
                    }} /></div>
            </div>
        </div>
    )
}
export default EcommerceFailed